import { ReactNode } from 'react';

import { Logo } from 'apps/shared/scripts/components';

import BackButton from '../Content/BackButton';

import MobileMenu from './MobileMenu';
import { innerClassName, navbarClassName, rightClassName } from './styles';

interface Props {
  goBack?: boolean;
  isMenuVisible?: boolean;
  onToggleMenu?: () => void;
  rightHeader?: ReactNode;
}

const Navbar = ({
  isMenuVisible,
  onToggleMenu,
  rightHeader,
  goBack,
}: Props) => {
  return (
    <nav id="navbar" className={navbarClassName}>
      <div className={innerClassName}>
        {goBack && <BackButton />}
        <Logo />
        <div className={rightClassName}>
          {rightHeader}
          {onToggleMenu && (
            <MobileMenu isMenuVisible={isMenuVisible} onToggle={onToggleMenu} />
          )}
        </div>
      </div>
    </nav>
  );
};

Navbar.displayName = 'Navbar';

export default Navbar;
